var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"type":"no-header"}},[_c('div',{staticClass:"page-text"},[_c('h1',[_vm._v(_vm._s(_vm.$t('pageTitle')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }